<template>
  <GrupoLeyendaCheck
    titulo="Avistamiento de fauna"
    checkboxType="switch"
    v-model="fauna_expanded"
  >
    <DaiInterruptorMapa
      class="control-mini interruptor-personalizado"
      v-width-control="'55%'"
      :opciones="['Malla', 'Pictogramas']"
      v-model="verMalla"
      :style="{'display':$store.state.mapa.mapaEnMobile ? 'none' : ''}"
    />
    <span 
      v-width-control="'40%'"
      :style="{'display':$store.state.mapa.mapaEnMobile ? 'inline-flex' : 'none'}"
    ></span>
    <BotonMasInfo @click="masInfo" v-width-control="'45%'" />
    <DaiLeyendaMapa
      para="fauna_hexbin"
      v-width-control="'100%'"
      class="l-fauna-hexbin"
      :class="{ hidden: verMalla !== 'Malla' }"
      :style="{'display':$store.state.mapa.mapaEnMobile ? 'none' : ''}"
    />
    <div :style="{'display':$store.state.mapa.mapaEnMobile ? 'block' : 'none'}">
      <p style="padding: 0 8px; margin-bottom: 0;">Debido al gran número de registros en las capas geográficas de avistamiento de fauna, así como su tipo de agrupamiento, estas son visibles únicamente en la versión de escritorio.</p>
    </div>
    <MultiselectorFauna v-width-control="'100%'" :style="{'display':$store.state.mapa.mapaEnMobile ? 'none' : ''}"/>
  </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
// import BotonQuitarTodos from "./utils/BotonQuitarTodos.vue";
import MultiselectorFauna from "./utils/MultiselectorFauna.vue";
import { scrollTo } from "@/components/_utils.js";

export default {
  components: {
    GrupoLeyendaCheck,
    BotonMasInfo,
    MultiselectorFauna,
    //BotonQuitarTodos
  },
  computed: {
    fauna_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.fauna;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "fauna",
          expandido: expandido,
        });
      },
    },
    verMalla: {
      get() {
        return this.$store.state.mapa.faunaVerMalla ? "Malla" : "Pictogramas";
      },
      set(valor) {
        this.$store.commit("mapa/setFaunaVerMalla", valor === "Malla");
      },
    },
  },
  methods: {
    masInfo() {
      this.$store.commit("mapa/setFichaActiva", "fauna");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
  },
};
</script>

<style lang="scss">
.l-fauna-hexbin {
  &.hidden {
    display: none;
  }
  .map-legend-item {
    pointer-events: none;
    cursor: default;
    .dai-map-shape {
      .shape {
        position: relative;
        border-radius: 0;
        border: none;
        height: 23px !important;
        width: 37px !important;
        &:after,
        &::before {
          content: "";
          position: absolute;
          width: 0;
          border-left: 18.5px solid transparent;
          border-right: 18.5px solid transparent;
        }
        &:before {
          bottom: 100%;
          border-bottom: 10.68px solid var(--shape-bg-color);
        }
        &:after {
          top: 100%;
          width: 0;
          border-top: 10.68px solid var(--shape-bg-color);
        }
      }
    }
    .map-legends-item-text {
      margin-top: 15px !important;
    }
  }
}
</style>